module.exports = __webpack_public_path__ + "595812eb4c8e8e3752c683ea50dd3340.svg";